const details = {
  id_item: null,
  name_item: "",
  id_unit: null,
  name_unit: "",
  volume_of: 1,
  purchase_price: 0
}


const exports = {
  details
}

export default exports